import { Text } from '@mantine/core'
import 'app/styles/components/plus-count-icon.css'

interface Props {
    count: number;
}

export default function PlusCountIcon({ count }: Props) {
    if (count <= 0) return null

    return (
        <span className={count > 100 ? 'plus-count-circle-lg' : count > 9 ? 'plus-count-circle-md' : 'plus-count-circle-sm'}>
            <Text className='plus-count-text'>
                +{count}
            </Text>
        </span>
    )
}